import { ChapterConfig } from "../../ChapterConfig";
import { OutlineBox } from "../../../Comps/OutlineBox/OutlineBox";
import { ChapterNav, ChapterNavItem } from "../ChapterNav/ChapterNav";
import { ChapterRoutes } from "../ChapterNav/ChapterRoutes";
import { ClearHelpers } from "../../Helpers/ClearHelpers/ClearHelpers";
import { Helpers } from "../../Helpers/Helpers";
import './SecondaryDominantsChapter.scss'
import { Music } from "../../../Util/Music/Music";
import { TransformTranslate } from "../../../Util/Transform/Transform";
import { HexMap } from "../../../Data/HexMap/HexMap";
import { HxMapGroup } from "../../../Comps/HxMap/HxMapGroup";
import { BuildHexMap } from "../../../Data/HexMap/HexMapBuilder";
import { HexMapModifier } from "../../../Data/HexMap/HexMapModifier";
import { MutableRefObject, useRef, useState } from "react";
import { produce } from "immer";
import { Note } from "../../../Data/HexMap/Note";
import { Key } from "../../../Data/HexMap/Key";
import { All } from "../../../Util/Constants/Quantities";
import { Chords } from "../../../Util/Music/Chords";
import { playChord } from "../../../Data/HexMap/NoteUtils";
import { NotePlayer } from "../../../Sound/NotePlayer";
import { useNotePlayer } from "../../../Sound/SoundStore";
import { Menu, MenuRadioGroup, MenuItem } from "@szhsin/react-menu";
import { MenuArrow } from "../../../Comps/Menu/MenuDownArrow";

export function SecondaryDominantsChapter(props:ChapterConfig){
    const subPaths:ChapterNavItem[] = [
        {title:'Lesson', path:'lesson', element:<ClearHelpers openHelpers={[Helpers.KeyCompass]}><Lesson/></ClearHelpers>}
    ]
    return  <div className={'secondary-dominants-chapter'}>
                <h1>Secondary Dominants</h1>
                <ChapterNav path={props.path} subPaths={subPaths}/>
                <ChapterRoutes chapterNavs={subPaths}/>
            </div>
}

export function Lesson(){
    const centerKey:number = 5
    const getHexMap = () => {
        const hexMap:HexMap = BuildHexMap({columns:4, rows:3, tonic:Music.Gb, radius:70})
        const mod:HexMapModifier = new HexMapModifier(hexMap)
        mod.keys_setOpen([All], false)
        mod.keys_setOpen([centerKey], true)
        mod.keys_setDefined([All], false)
        return hexMap
    }
    const [map, setMap] = useState(getHexMap())
    const mod:MutableRefObject<HexMapModifier> = useRef(new HexMapModifier(map))
    const notePlayer:MutableRefObject<NotePlayer> = useRef(useNotePlayer())
    const onNoteClick = (note:Note, e:React.MouseEvent) => {
        if(chordMode){
            const formula:number[] = (e.metaKey) ? Chords.Formula_seventh : Chords.Formula_triad
            playChord(note, formula, e, map, notePlayer.current)
            return
        }
        setMap(produce((draft:HexMap)=>{ 
            mod.current.setDraft(draft)
            mod.current.notes_advanceSelectedState([note.params.noteIndex])
        }))
    }
    const onKeyClick = (key:Key, e:React.MouseEvent) => {
        if(e.metaKey){
            setMap(produce((draft:HexMap)=>{ 
                    mod.current.setDraft(draft)
                    mod.current.keys_setOpen([key.params.keyIndex], !key.open)
                    mod.current.keys_removeClasses([key.params.keyIndex], ['ghosted'])
            }))
            return
        }
        if(e.shiftKey){
            setMap(produce((draft:HexMap)=>{ 
                    mod.current.setDraft(draft)
                    mod.current.keys_setOpen([key.params.keyIndex], false)
                    mod.current.keys_setDefined([key.params.keyIndex], false)
                    mod.current.keys_setDefault([key.params.keyIndex])
            }))  
            return
        }
        setMap(produce((draft:HexMap)=>{ 
                mod.current.setDraft(draft)
                mod.current.keys_setDefined([key.params.keyIndex], true)
                mod.current.keys_advanceSelectedState([key.params.keyIndex])
        }))   

    }
    const [chordMode, setChordMode] = useState(false)
    return(
        <OutlineBox title={'Dominant 5ths From Other Keys'} width={900}>
            <div className={'Lesson'}>
                <div className={'dominant-fifths-container'}>
                    <div>
                    <Menu menuButton={  <button type='button'>
                                            Chord Mode: {(chordMode) ? 'On' : 'Off'} <MenuArrow/>
                                        </button>}>
                        <MenuRadioGroup value={chordMode} onRadioChange={(e:any)=>{setChordMode(e.value)}}>
                                <MenuItem type="radio" value={true}>On</MenuItem>
                                <MenuItem type="radio" value={false}>Off</MenuItem>
                        </MenuRadioGroup>
                    </Menu>
                    </div>
                    <svg width={700} height={400}>
                        <g transform={TransformTranslate(350, 200)}>
                            <HxMapGroup onNoteClick={onNoteClick}
                                        onKeyClick={onKeyClick} 
                                        hexMap={map}/>
                        </g>
                    </svg>
                </div>
            </div>
 
        </OutlineBox>
    )
}
